<template>
  <el-row type="flex" :gutter="40">
    <el-col style="width:300px">
      <w-grp-list :active="active" @set-grp-filter="setGrpFilter" :grp-filters="grpFilters"></w-grp-list>
    </el-col>
    <el-col style="width:calc(100% - 300px)">
      <w-trigger-list-table :active="active" :grp-filters="grpFilters"></w-trigger-list-table>
    </el-col>
  </el-row>
</template>

<script>
import { isNil, isEqual } from 'lodash';
import WGrpList from './components/GrpList';
import WTriggerListTable from './components/TriggerListTable';

export default {
  name: 'WExecuteTrigger',
  components: {
    WGrpList,
    WTriggerListTable,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      grpFilters: [],
    };
  },
  methods: {
    setGrpFilter(item) {
      if (!isNil(item)) {
        if (item.selected) {
          this.grpFilters.push(item.grpId);
        } else {
          const deleteFilter = this.grpFilters.filter((grpId) => isEqual(grpId, item.grpId))[0];
          this.grpFilters.splice(this.grpFilters.indexOf(deleteFilter), 1);
        }
      } else {
        this.grpFilters = [];
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecuteTrigger/index.vue